/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_TimecodeInputs */

const en_ccsl_export_header_timecode = /** @type {(inputs: Ccsl_Export_Header_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TIMECODE`)
};

const fr_ccsl_export_header_timecode = /** @type {(inputs: Ccsl_Export_Header_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TIMECODE`)
};

const de_ccsl_export_header_timecode = /** @type {(inputs: Ccsl_Export_Header_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TIMECODE`)
};

const it_ccsl_export_header_timecode = /** @type {(inputs: Ccsl_Export_Header_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CODICE ORARIO`)
};

const ru_ccsl_export_header_timecode = /** @type {(inputs: Ccsl_Export_Header_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ТАЙМКОД`)
};

const es_ccsl_export_header_timecode = /** @type {(inputs: Ccsl_Export_Header_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CÓDIGO DE TIEMPO`)
};

const zh_cn2_ccsl_export_header_timecode = /** @type {(inputs: Ccsl_Export_Header_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间码`)
};

const ja_ccsl_export_header_timecode = /** @type {(inputs: Ccsl_Export_Header_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムコード`)
};

const hi_ccsl_export_header_timecode = /** @type {(inputs: Ccsl_Export_Header_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमकोड`)
};

const pt_pt2_ccsl_export_header_timecode = /** @type {(inputs: Ccsl_Export_Header_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CÓDIGO DE TEMPO`)
};

/**
* | output |
* | --- |
* | "TIMECODE" |
*
* @param {Ccsl_Export_Header_TimecodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_timecode = /** @type {((inputs?: Ccsl_Export_Header_TimecodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_TimecodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_timecode(inputs)
	if (locale === "de") return de_ccsl_export_header_timecode(inputs)
	if (locale === "it") return it_ccsl_export_header_timecode(inputs)
	if (locale === "ru") return ru_ccsl_export_header_timecode(inputs)
	if (locale === "es") return es_ccsl_export_header_timecode(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_timecode(inputs)
	if (locale === "ja") return ja_ccsl_export_header_timecode(inputs)
	if (locale === "hi") return hi_ccsl_export_header_timecode(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_timecode(inputs)
	return en_ccsl_export_header_timecode(inputs)
});